/**
 * A custom error class for HTTP errors.
 *
 * @example
 * const error = new HttpError(404, 'Not Found');
 * console.log(error.status); // 404
 * console.log(error.message); // 'Not Found'
 */
export class HttpError extends Error {
    /**
     * The HTTP error payload.
     */
    payload;
    /**
     * The HTTP status code.
     */
    status;
    /**
     * @param status - The HTTP status code.
     * @param message - The error message.
     * @param options - The error options.
     */
    constructor(status, message, options) {
        if (typeof message === 'object') {
            super(message.message, options);
            this.payload = message;
        }
        else {
            super(message, options);
            this.payload = { message };
        }
        this.status = status;
        this.name = 'HttpError';
    }
}
//# sourceMappingURL=HttpError.js.map